import { useQuery } from '@tanstack/react-query';
import { getPopularCropPrices, IPopularCropPrice } from '../../../api/crop-trends/getPopularCropPrices';
import { AxiosError } from 'axios';
import { getCropFavoritePrices, IFavoriteCropPrice } from '../../../api/crop-trends/getCropFavoritePrices';
import { useCheckUserLoggedIn } from '../../user/useCheckUserLoggedIn';

export const useGetCropFavoritePrices = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IFavoriteCropPrice[], AxiosError>(['favorite-crop-prices'], getCropFavoritePrices, {
    enabled: isUserLoggedIn,
  });
};
